import React from "react";

/**
 * Aviso legal obligatorio mostrado al ingresar al visor catastral.
 */
export default class InfoLegal extends React.Component {
  state = {
    open: true
  };

  accept = () => {
    this.setState({ open: false });
  };

  render() {
    if (!this.state.open) {
      return null;
    }

    return (
      <div
        className="modal is-active"
        role="dialog"
        aria-modal="true"
        aria-labelledby="aviso-legal-titulo"
      >
        <div className="modal-background" />
        <div className="modal-card" style={{ maxWidth: "850px", width: "calc(100% - 2rem)" }}>
          <header className="modal-card-head">
            <p id="aviso-legal-titulo" className="modal-card-title">
              AVISO LEGAL – RUN – LEY N.º 7424/2025
            </p>
          </header>
          <section className="modal-card-body" style={{ maxHeight: "65vh", overflowY: "auto" }}>
            <h2 className="title is-6">NATURALEZA JURÍDICA</h2>
            <p>
              La información geoespacial, gráfica y alfanumérica contenida en el
              presente Visor Web Catastral constituye una herramienta de consulta
              pública de carácter meramente referencial. No posee valor
              certificante, probatorio ni constitutivo de derechos.
            </p>
            <br></br>
            <h2 className="title is-6">ALCANCE DE LA BASE CARTOGRÁFICA</h2>
            <p>
              Los polígonos catastrales visualizados corresponden exclusivamente
              a los inmuebles georreferenciados e incorporados a la Base
              Cartográfica Institucional a partir de agosto de 2013. El Registro
              Unificado Nacional se encuentra en un proceso continuo de
              integración, depuración y actualización de la información catastral
              y registral.
            </p>
            <br></br>
            <h2 className="title is-6">SALVEDAD EXPRESA</h2>
            <p>
              La ausencia, inexactitud o desactualización de la representación
              gráfica de un inmueble no implica, presume ni acredita la
              inexistencia de derechos reales, derechos de dominio o posesión,
              títulos de propiedad ni antecedentes registrales relacionados con
              este.
            </p>
            <p>
              Asimismo, la visualización de un polígono en el Visor Web Catastral
              no convalida, perfecciona ni sanea vicios, defectos o
              inconsistencias técnicas o jurídicas que pudieran afectar al
              inmueble.
            </p>
            <p>
              Al hacer clic en la opción <strong>“Acepto”</strong>, la persona
              usuaria declara haber leído, comprendido y aceptado el contenido
              del presente aviso legal.
            </p>
          </section>
          <footer className="modal-card-foot" style={{ justifyContent: "flex-end" }}>
            <button type="button" onClick={this.accept} className="button is-primary">
              Acepto
            </button>
          </footer>
        </div>
      </div>
    );
  }
}
